import React, { FC, useCallback, useMemo, useState } from 'react'
import { TabListProps } from './types/TabList.types'
import './TabList.scss'
import {
  isEditorActive,
  Placeholder,
  Text,
  withSitecoreContext,
} from '@sitecore-jss/sitecore-jss-react'

const TabList: FC<TabListProps> = ({
  fields: { List } = { List: [] },
  rendering,
  sitecoreContext,
}) => {
  const isExperienceEditor = isEditorActive()

  const shouldRenderAll = useMemo(
    () => isExperienceEditor || sitecoreContext?.pageEditing,
    [sitecoreContext]
  )

  const [activeYear, setActiveYear] = useState(0)

  const handleYearClick: (newActiveYearIndex: number) => void = useCallback(
    (newActiveYearIndex) => setActiveYear(newActiveYearIndex),
    []
  )

  return (
    <div className="TabList">
      <div className="TabList__scroll">
        <div className="TabList__year_list">
          <div className="slick-slide">
            {List?.map(({ fields: { Title } }, idx) => (
              <button
                key={idx}
                className={activeYear === idx ? 'TabList__button_active' : ''}
                onClick={() => handleYearClick(idx)}
              >
                {activeYear === idx && <div></div>}
                {<Text field={Title} />}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="TabList__content">
        {shouldRenderAll
          ? List?.map(({ fields: { Title } }, idx) => {
              const placeholderName = `jss-list${idx}`
              return (
                <div key={idx} className={'tab-content TabList__active'}>
                  {`${idx} - ${Title?.value}`}
                  <Placeholder name={placeholderName} rendering={rendering!} />
                </div>
              )
            })
          : List?.map((_, idx) => {
              const placeholderName = `jss-list${idx}`
              return (
                <div
                  key={idx}
                  className={
                    activeYear === idx
                      ? 'tab-content TabList__active'
                      : 'tab-content'
                  }
                >
                  <Placeholder name={placeholderName} rendering={rendering!} />
                </div>
              )
            })}
      </div>
    </div>
  )
}

export default withSitecoreContext()(TabList)
